import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import DefaultButton from './DefaultButton';

const useStyles = makeStyles(theme => ({
  root: {
    '&:hover': {
      backgroundColor: theme.palette.tertiary.main
    }
  }
}));

const Button = props => {
  const { children, className = '', ...remainingProps } = props;
  const classes = useStyles();
  const classname = className ? clsx(classes.root, className) : classes.root;
  return (
    <DefaultButton className={classname} {...remainingProps}>
      {children}
    </DefaultButton>
  );
};

export default Button;
